import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import VendorManageNavigation from 'vendors/vendorManage/VendorManageNavigation'
import VendorManageInformation from 'vendors/vendorManage/views/VendorManageInformation'
import VendorManageContacts from 'vendors/vendorManage/views/VendorManageContacts'
import VendorManageServices from 'vendors/vendorManage/views/VendorManageServices'
import VendorManageWorkRegion from 'vendors/vendorManage/views/VendorManageWorkRegion'
import VendorManageHistoryTimeline from 'vendors/vendorManage/views/VendorManageHistoryTimeline'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'

const drawerWidth = '411px'

const VendorManage = () => {
  const theme = useTheme()
  const isWidescreen = useMediaQuery(theme.breakpoints.up('md'))

  const [drawerOpen, setDrawerOpen] = React.useState<boolean>(false)

  const toggleDrawer = (): void => {
    setDrawerOpen(!drawerOpen)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      {!isWidescreen && (
        <IconButton aria-label="menu" sx={{ margin: 1, mb: 0, alignSelf: 'flex-end' }} onClick={toggleDrawer}>
          <MenuIcon />
        </IconButton>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
        <Box
          sx={{
            maxWidth: '650px',
            ml: isWidescreen ? drawerWidth : 0,
            mt: isWidescreen ? 4 : 0,
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <VendorManageNavigation drawerOpen={drawerOpen} toggleDrawer={toggleDrawer} isWidescreen={isWidescreen} />
          <Routes>
            <Route path="information" element={<VendorManageInformation />} />
            <Route path="contacts" element={<VendorManageContacts />} />
            <Route path="services" element={<VendorManageServices />} />
            <Route path="region" element={<VendorManageWorkRegion />} />
            <Route path="history" element={<VendorManageHistoryTimeline />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  )
}

export default VendorManage
